export class IllegalStateError extends Error {
  readonly name: string

  readonly __proto__: IllegalStateError

  constructor(message = "Illegal State Error") {
    const prototype = new.target.prototype
    super(message)
    this.__proto__ = prototype
    this.name = "ILLEGAL_STATE_ERROR"
  }
}
